import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Component} from "@angular/core";
import {IAuditWebServiceClient, INotificationsCommonWebServiceClient} from "@common/resources/resources";
import {CerbaCookieService, UserStore, CorrespondantStore, ProfilValideDto, PopinCompteComponent} from "@digicerba/common";
import {TranslateService} from "@ngx-translate/core";
import { AsiDialogService } from "@asi-ngtools/lib";


@Component({
  selector: 'cerba',
  templateUrl: './cerba.component.html',
  host: {'class': 'flex'}
})
export class CerbaPageComponent {

  context: any;

  constructor(private router: Router, private auditWebServiceClient: IAuditWebServiceClient,
              private correspondantStore: CorrespondantStore,
              private userStore: UserStore,
              private translate: TranslateService,
              private activatedRoute: ActivatedRoute,
              private cookieService: CerbaCookieService,
              private notificationService: INotificationsCommonWebServiceClient,
              public asiDialogService: AsiDialogService) {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.auditWebServiceClient.info({url: event.url}).subscribe(() => {
        });
      }
    });
  }

  ngOnInit() {
    let tags: string[] = [];
    if (this.correspondantStore.getCorrespondant()) {
      tags = this.correspondantStore.getCorrespondant().tags;
    }
    this.context = {
      user: this.userStore.getUser(),
      domain: this.cookieService.getDomain(window.location.hostname),
      supportBaseUrl: this.cookieService.getSupportBaseUrl(window.location.hostname),
      nbAlerts: this.activatedRoute.snapshot.data['nbAlerts'],
      // Ajout des tags pour la gestion dynamique des outils du header et footer
      tags: tags,
    };

  }


  checkIFrame() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/cerba.component.ts